import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar.tsx'
import { cn } from '@/lib/utils.ts'
import { getInitials } from '@/utils/user.ts'
import type * as AvatarPrimitive from '@radix-ui/react-avatar'
import * as React from 'react'

interface UserAvatarProps extends React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Root> {
  member: Member | undefined | null
  size: 'xs' | 'sm' | 'md'
}

export const UserAvatar = React.forwardRef<React.ElementRef<typeof AvatarPrimitive.Root>, UserAvatarProps>(
  ({ member, size = 'md', className, ...props }, ref) => {
    const styles = {
      xs: 'h-4 w-4',
      sm: 'h-6 w-6',
      md: 'h-10 w-10',
    }

    const font = {
      xs: 'font-EN-KR-caption-bold',
      sm: 'font-EN-KR-body2-bold',
      md: 'font-EN-KR-heading3-bold',
    }

    return (
      <Avatar aria-label="avatar" className={cn('cursor-pointer', styles[size], className)} ref={ref} {...props}>
        {member?.avatarUrl && (
          <AvatarImage src={member.avatarUrl} referrerPolicy="no-referrer" alt={`${member?.name}-avatar-image`} />
        )}
        <AvatarFallback
          aria-label={`${member?.name}-avatar`}
          className={cn('bg-surface-secondary text-contents-onDarkPrimary', font[size])}
        >
          {getInitials(member?.name).charAt(0)}
        </AvatarFallback>
      </Avatar>
    )
  },
)
